import React from "react";
import "./IntroPage.css";

/* ── Assets ── */
import creativeImg       from "../../Assets/Images/creative.png";
import digitalImg        from "../../Assets/Images/digital.png";
import brandImg          from "../../Assets/Images/brand.png";
import officeimg         from "../../Assets/Images/officeimg.png";
import hivelogo          from "../../Assets/Images/hivelogo.png";
import hiveuserdashboard from "../../Assets/Images/hiveuserdashboard.png";

export default function IntroPage() {
  return (
    <div className="intro-page">

      {/* ══════════════════════════════════════════════
          SECTION 1 — Hero / Corporate Capability Note
      ══════════════════════════════════════════════ */}
      <section className="section-hero">
        <div className="hero-container">

          <h1 className="hero-title">Corporate Capability Note</h1>

          <p className="hero-body">
            Eilan Digital works as a structured creative and digital execution partner
            for businesses looking to improve communication clarity, consistency, and
            execution efficiency across platforms.
          </p>
          <p className="hero-body">
            We combine strategy, creative, production, and digital execution under one
            coordinated system, helping businesses reduce dependency on multiple agencies
            and fragmented communication workflows.
          </p>

          {/* ── Focus Box ── */}
          <div className="focus-outer">
            <div className="focus-label-row">
              <span className="focus-label-text">The focus remains simple</span>
            </div>
            <div className="focus-box">
              <p className="focus-box-copy">
                Simplify communication execution while maintaining quality,
                <br />
                speed, and operational clarity.
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* ══════════════════════════════════════════════
          SECTION 2 — Structured Team & Strategic Approach
      ══════════════════════════════════════════════ */}
      <section className="section-team">
        <div className="team-container">

          <h2 className="team-title">
            Structured Team<br />
            &amp; Strategic Approach
          </h2>
          <p className="team-subtitle">
            Eilan Digital operates through specialized teams across:
          </p>

      <div className="team-list-card">
  {[
    "Strategy & Research",
    "Creatives & Content",
    "Animation & 3D Visualization",
    "Website & Digital Platforms",
    "Photography & Videography",
    "Operations & Project Management",
  ].map((item, i) => (
    <div className="team-card" key={item}>
      <span className="team-card-num">
        {String(i + 1).padStart(2, "0")}
      </span>
      <span className="team-card-label">{item}</span>
    </div>
  ))}
</div>

          <p className="team-footnote">
            Every project is supervised by an Art Director and Project In-Charge
            responsible for execution planning, coordination, quality review, and
            delivery management.
          </p>

        </div>
      </section>

      <div className="office-img">
        <img
          src={officeimg}
          alt="Creative and Production"
          className="hive-img"
        />
      </div>

      {/* ══════════════════════════════════════════════
          SECTION 3 — Research Before Execution
      ══════════════════════════════════════════════ */}
      <section className="section-research">
        <div className="research-container">

          <div className="research-left">
            <h2 className="research-heading">
              Research<br />
              Before Execution
            </h2>
          </div>

          <div className="research-right">
            <div className="research-block">
              <p className="research-intro">
                Eilan Digital undertakes operational, product, market, and
                communication research before execution begins.
              </p>
            </div>
            <div className="research-block">
              <p className="research-highlight">
                This helps align communication decisions with business
                objectives, operational realities, and market positioning.
              </p>
            </div>
            <div className="research-block research-block--last">
              <p className="research-conclusion">
                The objective is to ensure that communication remains
                relevant, structured, and strategically aligned.
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* ══════════════════════════════════════════════
          SECTION 4 — Executive Framework
      ══════════════════════════════════════════════ */}
      <section className="section-framework">
        <div className="framework-container">

          <p className="framework-title-green">Eilan Digital's</p>
          <h2 className="framework-title-black">Executive Framework</h2>

          <div className="framework-grid">
            {[
              { num: "01", title: "Understanding & Research",  body: "Business, product, operational, and market understanding to establish communication direction." },
              { num: "02", title: "Strategy & Planning",       body: "Alignment of priorities, creative direction, timelines, and execution planning." },
              { num: "03", title: "Integrated Execution",      body: "Coordinated execution across creative, production, digital, and communication functions." },
              { num: "04", title: "Monitoring & Delivery",     body: "Execution visibility, progress tracking, quality review, and delivery management through HIVE." },
            ].map((card) => (
              <div className="framework-card" key={card.num}>
                <span className="fw-card-num">{card.num}</span>
                <h3 className="fw-card-title">{card.title}</h3>
                <p className="fw-card-body">{card.body}</p>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* ══════════════════════════════════════════════
          SECTION 5 — Execution Visibility Through HIVE
      ══════════════════════════════════════════════ */}
      <section className="section-hive">
        <div className="hive-container">

          {/* ── Heading with inline HIVE logo ── */}
          <h2 className="hive-title">
            Execution Visibility<br />
            Through <img src={hivelogo} alt="HIVE" className="hive-title-logo" />
          </h2>

          {/* ── Subtitle ── */}
          <p className="hive-subtitle">
            Eilan Digital operates on its internally developed Project Management System:
          </p>

          {/* ── Dashboard image with floating labels ── */}
          <div className="hive-dashboard-wrap">
            <img
              src={hiveuserdashboard}
              alt="HIVE User Dashboard"
              className="hive-dashboard-img"
            />
          </div>

          {/* ── Footnote ── */}
          <p className="hive-footnote">
            System driven approach ensures transparency, coordination and delivery
            discipline across projects.
          </p>

        </div>
      </section>

      {/* ══════════════════════════════════════════════
          SECTION 6 — Integrated In-House Capabilities
      ══════════════════════════════════════════════ */}
      <section className="section-capabilities">
        <div className="cap-container">

          <h2 className="cap-section-title">
            Integrated In-House<br />Capabilities
          </h2>

          <div className="cap-list">

            <div className="cap-card cap-card--1">
              <div className="cap-text">
                <span className="cap-num">01</span>
                <h3 className="cap-title">Creative &amp; Production</h3>
                <p className="cap-body">
                  Animation, and 3D product visualization. Photography,
                  videography, corporate &amp; process films.
                </p>
              </div>
              <div className="cap-img-wrap">
                <img src={creativeImg} alt="Creative and Production" />
              </div>
            </div>

            <div className="cap-card cap-card--2">
              <div className="cap-text">
                <span className="cap-num">02</span>
                <h3 className="cap-title">Digital &amp; Communication</h3>
                <p className="cap-body">
                  Website development, strategic content creation, digital
                  marketing, and communication support.
                </p>
              </div>
              <div className="cap-img-wrap">
                <img src={digitalImg} alt="Digital and Communication" />
              </div>
            </div>

            <div className="cap-card cap-card--3">
              <div className="cap-text">
                <span className="cap-num">03</span>
                <h3 className="cap-title">Brand Support</h3>
                <p className="cap-body">
                  Corporate presentations, campaign assets, print designs,
                  exhibition creatives, and communication systems.
                </p>
              </div>
              <div className="cap-img-wrap">
                <img src={brandImg} alt="Brand Support" />
              </div>
            </div>

          </div>

          <p className="cap-footnote">
            In-House capabilities enable stronger project ownership, faster execution,<br/>and better communication consistency across platforms.
          </p>

        </div>
      </section>

      {/* ══════════════════════════════════════════════
          SECTION 7 — Why Corporates Like To Work With Eilan Digital
      ══════════════════════════════════════════════ */}
      <section className="section-why">
        <div className="why-container">

          <h2 className="why-title">
            Why Corporates Like To Work<br />
            With Eilan Digital
          </h2>

          <p className="why-body">
            Businesses today often manage multiple agencies and vendors across branding,
            digital, content, and production requirements, leading to fragmented execution
            and coordination challenges.
          </p>
          <p className="why-body">
            Eilan Digital addresses this through an integrated execution structure where
            strategy, creative, production, and digital capabilities function under one
            coordinated system.
          </p>

          <div className="why-grid">
            {[
              "Single-point execution ownership",
              "Faster coordination and delivery",
              "Better communication consistency",
              "Reduced dependency on multiple vendors",
              "Greater execution visibility and accountability",
              "Stronger alignment between strategy and execution",
            ].map((item) => (
              <div className="why-card" key={item}>{item}</div>
            ))}
          </div>

        </div>
      </section>

      {/* ══════════════════════════════════════════════
          SECTION 8 — CTA / Footer Statement
      ══════════════════════════════════════════════ */}
      <section className="section-cta">
        <div className="cta-container">

          <p className="cta-statement">
            We combine strategic understanding, integrated execution, and <br/>
            operational discipline to support business communication with greater <br/>clarity, consistency &amp; execution control.
          </p>

          <p className="cta-visit-label">For more information, visit</p>

          <a
            href="https://www.eilandigital.com"
            className="cta-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.eilandigital.com
          </a>

        </div>
      </section>

    </div>
  );
}